<template>
  <div class="card-content">
    <div class="columns is-multiline">
      <div class="column is-12 has-text-weight-bold is-size-5 pdb-0">
        {{ relanceOption.libelleProduit}}
      </div>
      <div class="column is-2 pdt-0 is-size-7">
        <router-link-blank :to="{ name: 'c.bodac.devis',
                    params: {id: relanceOption.devisId}}"
                           :message="relanceOption.codeDevis"/>
        <span class="has-text-default">{{ relanceOption.dateDevis | formatDate }}</span>
      </div>
      <div class="column is-1 pdt-0">
        <b-field :label="$t('listeRelanceOption.card.week')"
                 custom-class="has-text-weight-light is-italic mgb-0">
          <span class="has-text-link has-text-weight-bold">
            {{ getAnneeSemaine(relanceOption.anneeSemaine) }}
          </span>
        </b-field>
      </div>
      <div class="column is-2 pdt-0">
        <b-field :label="$t('listeRelanceOption.card.payeur')"
                 custom-class="has-text-weight-light is-italic mgb-0">
          <p class="has-text-link has-text-weight-bold ellipsis">
            {{ relanceOption.payeur }}
          </p>
        </b-field>
      </div>
      <div class="column is-2 pdt-0">
        <b-field :label="$t('listeRelanceOption.card.annonceur')"
                 custom-class="has-text-weight-light is-italic mgb-0">
          <p class="has-text-link has-text-weight-bold ellipsis">
            {{ relanceOption.annonceur }}
          </p>
        </b-field>
      </div>
      <div class="column is-1 pdt-0">
        <b-field :label="$t('listeRelanceOption.card.face')"
                 custom-class="has-text-weight-light is-italic mgb-0">
          <p class="has-text-link has-text-weight-bold">
            {{ relanceOption.qteFacesSouhaitees }} / {{ relanceOption.qteFacesPrevues }}
          </p>
        </b-field>
      </div>
      <div class="column is-2 pdt-0">
        <b-field :label="$t('listeRelanceOption.card.commercial')"
                 custom-class="has-text-weight-light is-italic mgb-0">
          <p class="has-text-link has-text-weight-bold ellipsis">
            {{ getNameCommercial(relanceOption.commercialRelanceId) }}
          </p>
        </b-field>
      </div>
      <div class="column is-2 pdt-0">
        <span class="has-text-weight-light is-italic has-text-default">
          {{$t('listeRelanceOption.card.relancePar') }}
        </span>
        <span class="has-text-link has-text-weight-bold ellipsis">
          {{ getNameCommercial(relanceOption.commercialEnAttenteId) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { DEVIS } from '@/configuration/permissionsBodacConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    relanceOption: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      permDevis: DEVIS,
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    getAnneeSemaine(anneeSemaine) {
      return this.$i18n.t('listeRelanceOption.card.anneeSemaine', {
        week: anneeSemaine.toString().substring(4, 6),
        year: anneeSemaine.toString().substring(0, 4),
      });
    },
    getNameCommercial(commercialId) {
      const utilisateur = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find(u => u.id === commercialId);
      return utilisateur ? utilisateur.decorator.nomPrenom : this.$i18n.t('listeRelanceOption.card.noDefine');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
